module.exports = __webpack_public_path__ + "img/Szymon.71c1ad44.jpg";